'use client'
import { findWalletBookWallet } from '@dynamic-labs/wallet-book';
import { logger } from '../logger.js';

const getMobileExperience = ({ mobileExperienceProp, walletBook, walletKey, walletConnector, }) => {
    logger.logVerboseTroubleshootingMessage('[getMobileExperience]', {
        mobileExperienceProp,
        walletKey,
    });
    if (mobileExperienceProp) {
        // if the legacy prop is set, use that
        if (typeof mobileExperienceProp === 'string') {
            return mobileExperienceProp;
        }
        else if (mobileExperienceProp[walletKey]) {
            return mobileExperienceProp[walletKey];
        }
        else if (mobileExperienceProp.default) {
            return mobileExperienceProp.default;
        }
    }
    const walletBookRecord = findWalletBookWallet(walletBook, walletKey);
    logger.logVerboseTroubleshootingMessage('[getMobileExperience]', {
        isWalletConnect: walletConnector.isWalletConnect,
        walletBookRecord,
    });
    if (walletBookRecord === null || walletBookRecord === void 0 ? void 0 : walletBookRecord.mobileExperience) {
        return walletBookRecord.mobileExperience;
    }
    // a hack to only apply this experience on v4+ sdks, otherwise we would have it changed to redirect
    if (walletKey === 'metamask') {
        return 'redirect';
    }
    // default to redirect for WC wallets
    if (walletConnector.isWalletConnect) {
        return 'redirect';
    }
    return 'in-app-browser';
};

export { getMobileExperience };
